
import { fromTime, fromFormatDate } from '../functions/Utilities';

const General = (props) => {  

return (  
        <div className="notice"> 
            <div className="notice_body" id="share">
            <div className="notice_type notice_general">NOTICE</div>
                <div className="general">{ props.notice.notice_title.toUpperCase()} </div>  
                <div className="telephone_message"> 
                { props.notice.notice_text.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")}  
                </div> 
            </div> 
        </div> 
    );
}

export default General;

